import { render } from "./ladderTracker.vue?vue&type=template&id=33cc0952&scoped=true"
import script from "./ladderTracker.vue?vue&type=script&lang=js"
export * from "./ladderTracker.vue?vue&type=script&lang=js"

import "./ladderTracker.vue?vue&type=style&index=0&id=33cc0952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33cc0952"]])

export default __exports__